import React from 'react';

import {MonitorFiltersFormHandler} from 'entities/monitor';
import {IPortMonitorFiltersForm} from 'features/port/model/PortMonitor/IPortMonitorFiltersForm';
import IPortMonitorsFilters from 'features/port/model/PortMonitor/IPortMonitorsFilters';
import {stringToBoolean} from 'shared/lib/filterHelper';

import PortMonitorFiltersForm from './PortMonitorFiltersForm/PortMonitorFiltersForm';

interface IPortMonitorFiltersFormHandlerProps {
    onSuccess: () => void;
    handleClose: () => void;
}

const buildFilters = ({ok, ...rest}: Omit<IPortMonitorFiltersForm, 'tags' | 'orderBy'>) => {
    const data: IPortMonitorsFilters = {...rest};

    if (ok !== null && ok !== undefined) {
        data.ok = stringToBoolean(ok);
    }

    return data;
};

const PortMonitorFiltersFormHandler: React.FC<IPortMonitorFiltersFormHandlerProps> = (props) => (
    <MonitorFiltersFormHandler
        {...props}
        FiltersForm={PortMonitorFiltersForm}
        buildFilters={buildFilters}
    />
);

export default PortMonitorFiltersFormHandler;
